import React from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import Box from '@mui/material/Box/Box';
import { ChartLegend } from '../../../../../../../components/chart-legend/chart-legend';
import { Segment } from '../../types';
import { formatHour, heatmapColors } from '../../utils';

const data: Segment[] = [{ pricingTier: 0, value: 1, start: 0, end: 24 }];

export const ChartG11: React.FC = () => {
  const { t } = useTranslation('channel-details');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            startAngle={90}
            endAngle={-270}
            data={data}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={90}
            fill={heatmapColors[3]}
            animationDuration={500}
            paddingAngle={3}
            labelLine={false}
            label={({ cx, cy, start, end }) => (
              <text
                x={cx}
                y={cy - 110}
                textAnchor="middle"
                dominantBaseline="central"
                style={{ fontSize: 14, fontWeight: 'bold' }}
                fill="var(--color-type-primary)"
              >
                {`${formatHour(start)} - ${formatHour(end)}`}
              </text>
            )}
          />
        </PieChart>
      </ResponsiveContainer>
      <ChartLegend items={[{ label: t('allDayZone'), color: heatmapColors[3] }]} dotSize={16} fontSize={14} />
    </Box>
  );
};
